<template>
  <div>
    <div class="topsearch-container">
      <a-form :model="MIXINTopSearchParams" v-bind="MIXINTopSearchFormSetting">
        <a-row>
          <a-col v-bind="MIXINDefaultTopSearchSigns">
            <a-form-item label="活动名称">
              <a-input v-model="MIXINTopSearchParams.name" allowClear placeholder="输入活动名称" />
            </a-form-item>
          </a-col>
          <a-col v-bind="{ xxl: 8, xl: 10, lg: 12, md: 16, sm: 24, xs: 24 }">
            <a-form-item label="业务线" v-bind="{ labelCol: { span: 3 }, wrapperCol: { span: 20 } }">
              <ProjectLine v-model="MIXINTopSearchParams.line_id" placeholder="选择业务线" />
            </a-form-item>
          </a-col>
          <a-col v-bind="MIXINDefaultTopSearchSigns">
            <a-form-item label="活动类型">
              <a-select v-model="MIXINTopSearchParams.category_id" allowClear placeholder="选择活动类型" >
                <a-select-option
                  v-for="activityType in activityTypeDataSource"
                  :key="activityType.id"
                  :value="activityType.id">
                  {{ activityType.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col v-bind="MIXINDefaultTopSearchSigns">
            <a-form-item label="活动状态">
              <a-select v-model="MIXINTopSearchParams.status" allowClear placeholder="选择活动状态" >
                <a-select-option value="1">未开始</a-select-option>
                <a-select-option value="2">进行中</a-select-option>
                <a-select-option value="3">已结束</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col v-bind="MIXINDefaultTopSearchSigns" class="topsearch-submit">
            <a-button type="primary" icon="search" @click="handleTopSearchSubmit">
              查询</a-button>
            <a-button type="primary" icon="delete" ghost @click="handleTopSearchClear">
              清空</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-divider :dashed="true" class="divider--notop" />
    <div>
      <a-button
        type="primary"
        icon="plus-circle"
        class="activity-add-btn"
        @click="handleOpenDialog(null, 1)">
        添加活动
      </a-button>
      <a-table row-key="id" v-bind="MIXINTableSetting" @change="handleTableChange">
        <template slot="operator" slot-scope="text, record">
          <a-button type="link" size="small" @click="handleOpenDialog(record, 2)">
            编辑</a-button >
          <a-button type="link" size="small" @click="handleOpenDialog(record, 3)">
            查看</a-button>
          <a-popconfirm
            title="您确认删除吗？"
            ok-text="删除"
            cancel-text="取消"
            @confirm="confirmDelete(record)">
            <a-button type="link" size="small">删除</a-button>
          </a-popconfirm>
        </template>
      </a-table>
    </div>
    <a-modal
      :title="getDialogTitle"
      :visible="dialogVisible"
      :confirm-loading="dialogConfirmLoading"
      @ok="handleOk"
      @cancel="dialogVisible = false">
      <a-form-model
        ref="dialogForm"
        :model="dialogForm"
        :rules="dialogFormRules"
        v-bind="dialogSetting">
        <a-form-model-item v-if="isDetailsTypeDialog" label="中奖记录">
          <a-button icon="link" type="link" @click="() => $router.push({ path: `/activities-set/prize-claim/${dialogForm.id}` })">
            查看</a-button>
        </a-form-model-item>
        <a-form-model-item label="活动名称" prop="name">
          <a-input v-model="dialogForm.name" :disabled="isDetailsTypeDialog || isUpdateTypeDialog" placeholder="请输入活动名称" />
        </a-form-model-item>
        <a-form-model-item label="活动类型" prop="category_id">
          <a-select v-model="dialogForm.category_id" :disabled="isDetailsTypeDialog || isUpdateTypeDialog" placeholder="请选择活动类型" >
            <a-select-option
              v-for="activityType in activityTypeDataSource"
              :key="activityType.id"
              :value="activityType.id">
              {{ activityType.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="业务线" prop="line_id">
          <ProjectLine v-model="dialogForm.line_id" :disabled="isDetailsTypeDialog || isUpdateTypeDialog" placeholder="选择业务线" />
          <!-- <a-select v-model="dialogForm.line_id" :disabled="isDetailsTypeDialog || isUpdateTypeDialog" placeholder="请选择业务线" >
            <a-select-option
              v-for="platform in lineListEnum"
              :key="platform.id"
              :value="platform.id">
              {{ platform.org }}
            </a-select-option>
          </a-select> -->
        </a-form-model-item>
        <a-form-model-item label="开始时间" prop="start_time">
          <a-date-picker
            v-model="dialogForm.start_time"
            show-time
            :disabled="isDetailsTypeDialog || (isUpdateTypeDialog && isStartOverCurrentTimeRange)"
            placeholder="请选择开始时间"
            format="YYYY-MM-DD HH:mm:ss"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            :disabled-date="disabledDate"
            style="width: 100%;"/>
        </a-form-model-item>
        <a-form-model-item label="结束时间" prop="end_time">
          <a-date-picker
            v-model="dialogForm.end_time"
            show-time
            :disabled="isDetailsTypeDialog|| (isUpdateTypeDialog && isEndOverCurrentTimeRange)"
            placeholder="请选择结束时间"
            format="YYYY-MM-DD HH:mm:ss"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            :disabled-date="disabledDate"
            style="width: 100%;"/>
        </a-form-model-item>
        <a-divider :orientation="isDetailsTypeDialog ? 'left' : 'right'">
          <div v-if="isDetailsTypeDialog || isUpdateTypeDialog">奖品信息</div>
          <a-button v-else type="primary" ghost @click="handleAddPrize">添加奖品</a-button>
        </a-divider>
        <div class="dialog-prize-list">
          <a-row
            v-for="(prize, prizeIndex) in dialogForm.prize"
            :key="prizeIndex"
          >
            <a-col :span="13">
              <a-form-model-item :label="`奖品${ prizeIndex + 1 }`" :labelCol="{ span: 6 }" :wrapperCol="{ span: 17 }">
                <a-cascader
                  v-model="prize.id"
                  :options="prizeDataSource"
                  :disabled="isDetailsTypeDialog || isUpdateTypeDialog"
                  placeholder="请选择奖品"
                  popup-class-name="activity-dialog-cascader">
                  <template slot="displayRender" slot-scope="{labels}">
                    {{ labels[labels.length - 1] }}
                  </template>
                </a-cascader>
              </a-form-model-item>
            </a-col>
            <a-col :span="7">
              <a-form-model-item label="数量" prop="prize" :labelCol="{ span: 7 }" :wrapperCol="{ span: 12 }">
                <a-input-number
                  v-model="prize.total"
                  :disabled="isDetailsTypeDialog || dialogForm.status === '已结束'"
                  :min="1" />
              </a-form-model-item>
            </a-col>
            <a-col :span="3" v-if="!(isDetailsTypeDialog || isUpdateTypeDialog)">
              <a-button
                type="danger"
                shape="circle"
                icon="close"
                size="small"
                class="dialog-list-delbtn"
                @click="handleDeletePrize(prizeIndex)"/>
            </a-col>
          </a-row>
        </div>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import _ from 'lodash'
import api from '@/api/'
import moment from 'moment'
import { ReuseMixin } from '../mixins/reuse'
import lineList from '@/mixins/lineList'
import { mapGetters } from 'vuex'
import ProjectLine from '@/components/ProjectLine'
export default {
  name: 'ActivitySet',
  mixins: [ReuseMixin, lineList],
  components: { ProjectLine },
  data() {
    return {
      dialogVisible: false,
      dialogConfirmLoading: false,
      pitchOnDialogType: 1,
      pitchOnDialogStorage: null,
      dialogForm: { category_id: undefined, name: '', line_id: undefined, start_time: '', end_time: '', prize: [] },
      dialogFormRules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 1, max: 50, message: '不超过50字', trigger: 'blur' },
        ],
        category_id: [
          { required: true, message: '请选择活动类型', trigger: 'change' }
        ],
        line_id: [
          { required: true, message: '请选择业务线', trigger: 'change' }
        ],
        start_time: [
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        end_time: [
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ],
      },
      dialogSetting: { labelCol: { span: 4 }, wrapperCol: { span: 17 } },
      prizeDataSource: [],
      activityTypeDataSource: [],
      tableColumns: [
        { title: 'ID', dataIndex: 'id' },
        { title: '活动名称', dataIndex: 'name' },
        { title: '活动类型', dataIndex: 'category', customRender: (_, record) => record.category.name },
        { title: '业务线', dataIndex: 'org' },
        { title: '开始时间', dataIndex: 'start_time' },
        { title: '结束时间', dataIndex: 'end_time' },
        { title: '状态', dataIndex: 'status' },
        { title: '操作', dataIndex: 'operator', width: 200,
          scopedSlots: { customRender: 'operator' } },
      ]
    }
  },
  computed: {
    ...mapGetters(['lineListEnum']),
    getDialogTitle() {
      switch (this.pitchOnDialogType) {
        case 1:
          return '新增活动'
        case 2:
          return '编辑活动'
        case 3:
          return '活动详情'
        default:
          return ''
      }
    },
    isDetailsTypeDialog() {
      return this.pitchOnDialogType === 3
    },
    isUpdateTypeDialog() {
      return this.pitchOnDialogType === 2
    },
    isStartOverCurrentTimeRange() {
      return this.dialogForm.start_time ? moment(this.dialogForm.start_time).valueOf() < new Date().getTime() : false
    },
    isEndOverCurrentTimeRange() {
      return this.dialogForm.end_time ? moment(this.dialogForm.end_time).valueOf() < new Date().getTime() : false
    }
  },
  watch: {
    dialogVisible(visible) {
      if (!visible) {
        this.dialogForm = _.cloneDeep({ category_id: undefined, name: '', line_id: undefined, start_time: '', end_time: '', prize: [] })
        this.$refs.dialogForm.clearValidate()
      }
    },
  },
  methods: {
    // type: 1 => 新增 2 => 修改 3 => 查看
    handleOpenDialog(record, type) {
      this.pitchOnDialogType = type
      if (record) {
        const params = _.cloneDeep(record)
        params.line_id = Number(params?.line_id) || undefined
        this.dialogForm = { ...params, prize: params.prize.map(item => ({ id: [item.category_id, item.id], total: Number(item.total) })) }
      }
      this.dialogVisible = true
    },
    handleOk() {
      if (this.pitchOnDialogType === 3) {
        this.dialogVisible = false
        return
      }
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          const isCreated = this.pitchOnDialogType === 1
          this.dialogConfirmLoading = true
          try {
            const params = _.cloneDeep(this.dialogForm)
            params.start_time = moment(params.start_time).format('YYYY-MM-DD HH:mm:ss')
            params.end_time = moment(params.end_time).format('YYYY-MM-DD HH:mm:ss')
            params.prize = params.prize.filter(prize => prize.id && prize.id.length).map(prize => ({ ...prize, id: prize.id[prize.id.length - 1] }))
            const { code } = isCreated ? await api.createdActivitiesSet(params) : await api.updateActivitiesSet(params)
            if (code === '000000') {
              this.$notification.success({
                message: '操作成功',
                description: `活动【${params.name}】已成功${ isCreated ? '创建' : '更新' }`,
              })
              this.MIXINHandleRefreshTable(this.fetchOriginList)
              this.dialogVisible = false
            }
            this.dialogConfirmLoading = false
          } catch {
            this.dialogConfirmLoading = false
          }
        } else {
          return false
        }
      })
    },
    async fetchPrize() {
      const { code, data } = await api.fetchPrizeTypeList({ page: 1, per_page: 2000, prize: 1 })
       try {
         this.prizeDataSource = code === '000000' ? data.category.filter(item => item.prize.length).map(item => {
            return {
            value: String(item.id),
            label: item.name,
            children: item.prize.map(prize => ({ value: prize.id, label: prize.name, children: null }))
          }
         }) : []
       } catch {
         this.prizeDataSource = []
       }
    },
    async fetchActivityType() {
       const { code, data } = await api.fetchActivityTypeList({ page: 1, per_page: 2000 })
       try {
         this.activityTypeDataSource = code === '000000' ? data.category : []
       } catch {
         this.activityTypeDataSource = []
       }
    },
    async fetchOriginList() {
      const DefaultPagination = { page: 1, per_page: 10, total: 0 }
      try {
        const { code, data } = await api.fetchActivitiesSetList(this.MIXIXGetTableTransferAllParams())
        const isSucceed = code === '000000'
        return {
          list: isSucceed ? data.activity : [],
          pagination: isSucceed ? data.pagination : { ...DefaultPagination },
        }
      } catch {
        return { list: [], pagination: { ...DefaultPagination } }
      }
    },
    async confirmDelete(record) {
      const { code } = await api.deleteActivitiesSet(record)
      if (code === '000000') {
        this.$notification.success({
          message: '操作成功',
          description: `活动【${record.name}】已成功删除`,
        })
        this.MIXINHandleRefreshTable(this.fetchOriginList)
      }
    },
    handleTopSearchSubmit() {
      this.MIXINSaveTopSearchParamsToStorage(() =>
        this.MIXINHandlePageChange(this.fetchOriginList, 1)
      )
    },
    handleTopSearchClear() {
      this.MIXINClearTopSearchParams(() =>
        this.MIXINHandlePageChange(this.fetchOriginList, 1)
      )
    },
    handleTableChange({ current, pageSize }) {
      this.MIXINHandlePageChange(this.fetchOriginList, current, pageSize)
    },
    handleAddPrize() {
      this.dialogForm.prize.push(_.cloneDeep({ id: [], total: 1 }))
    },
    handleDeletePrize(prizeIndex) {
      this.dialogForm.prize.splice(prizeIndex, 1)
    },
    disabledDate(current) {
      return current && current < moment().subtract(1, 'days').endOf('day')
    }
  },
  created() {
    this.MIXINInit({
      beforeInit: () => {
        this.fetchPrize()
        this.fetchActivityType()
      },
      tableColumns: this.tableColumns,
      topSearchParams: { name: '', category_id: undefined, line_id: undefined, status: undefined },
      afterInit: () => this.MIXINHandlePageChange(this.fetchOriginList, 1),
    })
  },
}
</script>

<style scoped lang='less'>
@import url(../style/public.less);
.dialog-prize-list {
  max-height: 180px;
  overflow: auto;
}

.dialog-list-delbtn {
  margin-top: 8px;
}

</style>

<style>
.activity-dialog-cascader ul {
  width: 220px!important;
}
</style>
